import { axiosInstance } from "../../utils/axios";
import { AxiosResponse } from "axios";
import { ElaborationRequest, ElaborationResponse } from "../models";

export type ElaborationItemType = "NEW" | "EDIT" | "REFRESH" | "REFRESH_COMPONENT_INSTANCE";
export type ElaborationDepthLevelType = "DEEPEST" | "SHALLOWEST";
export type ObjectUpdateOptionType = "DATAFULL" | "DATALESS";

export interface UpdateOptions {
  depthLevel?: ElaborationDepthLevelType;
  objectUpdateOption?: ObjectUpdateOptionType;
}

export interface CallbackElaborationStatusBase {
  correlationId: string;
  clientId: string;
  documentId: string;
  userId: string;
}

export interface CallbackElaborationStatus extends CallbackElaborationStatusBase {
  items: CallbackElaborationStatusItem[];
}

export interface CallbackElaborationsSnapshotStatus {
  snapshot: CallbackElaborationStatus[];
}

export interface CallbackSingleElaborationItemStatus extends CallbackElaborationStatusBase {
  singleItem: CallbackElaborationStatusItem;
}

export interface CallbackHeartbeatStatus {
  up: string;
}

export interface CallbackElaborationStatusItem {
  id: string;
  contentControlId: string;
  status:
    | "REQUESTED"
    | "STARTED"
    | "REJECTED"
    | "REJECTED_FOR_CONCURRENCY"
    | "FAILED"
    | "COMPLETED"
    | "REJECTED_FOR_OBJECT_NOT_FOUND"
    | "ABORTED";
  startDate: string;
  endDate: string;
  elabResult: string;
  elabResultType: ElabResultType;
  correlationId: string;
  formSheetAreaId: CallbackElaborationFormSheetArea;
  resultAdded: boolean;
  userChecked: boolean;
  messages: CallbackElaborationMessage[];
  objectName: string;
}

export type ElabResultType = "HTML" | "STRINGBASE64" | "IMAGE_STRINGBASE64" | "REF_URL" | "INTERNAL_REF_URL" | "TEXT";

export interface CallbackElaborationFormSheetArea {
  dbId: string;
  formId: string;
  sheet: string;
  area: string;
}

export interface CallbackElaborationMessage {
  text: string;
  details: string;
  severity: string;
  traceId: string;
}

export function createElaborationRequest(elaboration: ElaborationRequest): Promise<ElaborationResponse> {
  return axiosInstance
    .post(`/elaboration/create`, elaboration, {
      params: { generatesElaboration: true },
    })
    .then((resp) => resp.data);
}

export function confirmElaborationItemResultAdd(itemId: string): Promise<AxiosResponse> {
  return axiosInstance.post(`/elaboration/item/${itemId}/confirmElaborationResultAdd`);
}

export function confirmElaborationItemUserCheck(itemId: string): Promise<AxiosResponse> {
  return axiosInstance.post(`/elaboration/item/${itemId}/confirmElaborationUserCheck`);
}

export function confirmElaborationItemsResultAddAndUserChecked(
  correlationId: string,
  addedItemIds: string[],
  userCheckedItemIds: string[]
): Promise<AxiosResponse[]> {
  return axiosInstance.post(
    `/elaboration/items/confirm`,
    {
      correlationId: correlationId,
      addedItemIds: addedItemIds,
      userCheckedItemIds: userCheckedItemIds,
    },
    {
      params: { notShowLoading: true },
    }
  );
}

export function notifyFailedElaboration(itemId: string, error: string): Promise<AxiosResponse> {
  return axiosInstance.post(`/elaboration/item/${itemId}/notifyFailedElaboration`, error);
}

export function confirmElaborationItemsResultAddSilent(itemId: string): Promise<AxiosResponse[]> {
  return axiosInstance.post(`/elaboration/item/${itemId}/notNotifiedConfirmElaborationResultAdd`);
}
